import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const EmailLockedIcon = (props: IconProps) => (
  <Icon width="25px" height="24px" viewBox="0 0 25 24" {...props}>
    <path
      fillRule="evenodd"
      d="M14 2H3L1 4v12l2 2h11v-2H3V6l8 5 3-2V7l-3 2-8-5h11V2Z"
      clipRule="evenodd"
    />
    <path d="m19 19 3-3c0-2-2-3-3-3-2 0-3 1-3 3 0 1 1 3 3 3Zm5 4-1-2a10 10 0 0 0-8 0l-2 2v1h11v-1ZM22 4V3c0-2-2-3-3-3-2 0-3 1-3 3v1l-2 2v4l2 1h6l1-1V6l-1-2Zm-5 0V3l2-2 1 2v1h-3Z" />
  </Icon>
);

export default memo(EmailLockedIcon);
